import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import map from 'lodash/map';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import { makeStyles } from 'tss-react/mui';
import Skeleton from '@mui/material/Skeleton';
import { Paper } from '@mui/material';

import { fetchPicks } from '../store/actions/index';
import Image from './Image';
import FlickityWrapper from '../utils/FlickityWrapper';
import { ReactComponent as Marvel } from '../images/marvel.svg';
import { ReactComponent as DcComics } from '../images/dccomics.svg';
import { ReactComponent as OtherComics } from '../images/other.svg';

const useStyles = makeStyles()(() => ({
  card: {
    backgroundColor: `rgba(0, 0, 0, 0)`,
    boxShadow: `none`,
  }
}));

const PicksList = () => {
  const picks = useSelector((state) => state.picks.all);
  const dispatch = useDispatch();

  useEffect(() => {
    if (picks.length === 0) {
      dispatch(fetchPicks());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [picks]);

  const {classes} = useStyles();


  const renderBackground = (pick) => {
    if (pick.brand_name === `Marvel Comics`) {
      return <Marvel />;
    }

    if (pick.brand_name === `DC Comics`) {
      return <DcComics />;
    }

    return <OtherComics />;
  }

  const renderPicks = () => {
    if (!picks || picks.length === 0) {
      const loading = new Array(10);

      return map(loading, (item, i) => {
        return (
          <div
            className="pick"
            key={i}
          >
            <Card className={classes.card}>
              <Skeleton variant="rect" width={768} height={350} />
            </Card>
          </div>
        );
      });
    }

    return map(picks, (pick) => {
      const link = `/products/${pick.product_id}/${pick.product_url_title}`
      const brandName = (pick.brand_name === `DC Comics`) ? `feature__dccomics` :
        (pick.brand_name === `Marvel Comics`) ? `feature__marvel` : ``;

      return (
        <div
          className={`feature--item__container ${brandName}`}
          key={pick.product_id}
        >
          {renderBackground(pick)}
          <div className="feature--item">
            <div className="feature--image">
              <Card>
                <Link to={link}>
                  <Image
                    imgSmall={pick.filename_small}
                    imgLarge={pick.filename_large}
                    name={pick.name}
                  />
                </Link>
              </Card>
            </div>

            <div className="feature--content">
              <Link className="feature--title" to={link}>{pick.name}</Link>
              <span>{pick.brand_name}</span>
              <p>
                <Button
                  variant="contained"
                  color="primary"
                  component={Link}
                  to={link}
                >
                  Shop now
                </Button>
              </p>
            </div>
          </div>
        </div>
      );
    });
  }

  return (
    <React.Fragment>
      <div className="home--container">
        <h2 className="home--heading">This week&rsquo;s favorite comic books</h2>
      </div>
      <FlickityWrapper
        picks={picks}
        slides={renderPicks()}
        className="feature--container"
        options={{
          autoPlay: 4000,
          adaptiveHeight: true,
          friction: 0.7,
        }}
      />
      <div className="home--container">
        <p className="text--instructions"><em>Use the <Link to="/checklist">Pull List</Link> to purchase this week’s comics and toys before they sell out!</em></p>
      </div>
    </React.Fragment>
  );
}

PicksList.propTypes = {
  fetchPicks: PropTypes.func,
  picks: PropTypes.array,
};

export default PicksList;
